// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__3EpsC","headerCell":"styles_headerCell__Z0NF0"};